<script lang="ts">
  import { CustomSpinner } from '$shared/components';
  import UIMessage from '$shared/constants/UIMessages';

  interface Props {
    label: string | null | undefined;
  }

  let { label }: Props = $props();
</script>

<div data-cy="process-loader" class="comp-entity-process-loader">
  <div class="container">
    <div class="spinner">
      <CustomSpinner size={30} />
    </div>
    <div class="label">{label || UIMessage.VerificationProcessing}</div>
  </div>
</div>

<style>
  .comp-entity-process-loader {
    width: 100%;
    height: 150px;
    background-color: var(--grey-bg);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .comp-entity-process-loader .container {
    width: 100%;
    color: var(--grey-medium);
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .comp-entity-process-loader .container .spinner {
    margin-right: 8px;
  }
</style>
